import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Routes, Route, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import SearchBox from "../../../Component/DigitalMarketing/SearchBox";
import Toast from "../../../Component/DigitalMarketing/Toast";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import facebook from "../../../assets/DigitalMarketing/image/integration/logos_facebook.svg";
import google from "../../../assets/DigitalMarketing/image/integration/google.svg";
import chatbot from "../../../assets/DigitalMarketing/image/integration/cryptocurrency-color_chat.svg";
import whatsapplogo from "../../../assets/DigitalMarketing/image/integration/whatsapp.svg";
import rightarrow from "../../../assets/DigitalMarketing/image/integration/right arrow.svg";
import { Change } from "../../../store/async-actions/digitalmarketing/header";
import {
  useGetFacebooksettingQuery,
  useGetWhatsappsettingQuery,
} from "../../../Service/Integration";
import PermissionCheck from "../../../Component/PermissionCheck";

function Integration() {
  const [show, setshow] = useState(false);
  const dispatch = useDispatch<any>();
  const [branchList, setBranchList] = useState([]);
  const { open, message, openSnackBar, type } = useSnackbar();
  const { data: whatsappSetting } = useGetWhatsappsettingQuery("1", {
    refetchOnMountOrArgChange: true,
  });
  const { data: facebookSetting } = useGetFacebooksettingQuery("1", {
    refetchOnMountOrArgChange: true,
  });
  useEffect(() => {
    const data: any = {
      first: "Integration",
    };
    dispatch(Change(data));
  }, [dispatch]);
  const navigate = useNavigate();
  return (
    <>
      <Toast open={open} type={type} message={message} />
      <Container fluid>
        <Row className="integration-layout">
          <Col md={7}>
            <div className="integration-innerlayout mt-5">
              <img className="icon-img me-3" src={facebook} alt="facebook" />
              <span>
                <small className="integration-chat">Facebook</small>
              </span>
              <h1 className="integration-message mt-2">
                Receive new leads from facebook and redirect them to your
                mimokonnect account
              </h1>
              <div className="d-flex justify-content-between mt-3">
                <small className="integration-notConnect">
                  {" "}
                  {!facebookSetting?.userAccountId
                    ? "Not Connect"
                    : "Connected"}
                </small>
                <small className="integration-connect">
                    <Link to="facebook">Connect &nbsp;{">"}</Link>
                </small>
              </div>
            </div>
            {/* <Row>
              <Col className="flex-left">
                <small className="integration-notConnect">Not Connect</small>
              </Col>
              <Col className="flex-right">
                <small className="integration-connect">
                  <Link to="facebook">Connect{">"}</Link>
                </small>
              </Col>
            </Row> */}
          </Col>
          {/* <Col md={7}>
            <div className="integration-innerlayout">
              <img className="icon-img me-3" src={google} alt="google" />
              <span>
                <small className="integration-chat">Google</small>
              </span>
              <h1 className="integration-message mt-2">
                Receive new leads from google and redirect them to your
                mimokonnect account
              </h1>
              <div className="d-flex justify-content-between mt-3">
                <small className="integration-notConnect">Not Connect</small>
                <small className="integration-connect">
                  <Link to="google">Connect &nbsp;{">"}</Link>
                </small>
              </div>
            </div>
          </Col> */}
          {/* <Col md={7}>
            <div className="integration-innerlayout">
              <img className="icon-img me-3" src={chatbot} alt="chatbot" />
              <span>
                <small className="integration-chat">Chatbot</small>
              </span>
              <h1 className="integration-message mt-2">
                Receive new leads from ChatBot & Integration Lead Ads in your
                Mind and Mom account
              </h1>
              <div className="d-flex justify-content-between mt-3">
                <small className="integration-notConnect">Not Connect</small>
                <small className="integration-connect">
                  <Link to="chatbot">Connect &nbsp;{">"}</Link>
                </small>
              </div>
            </div>
          </Col> */}
          <Col md={7}>
            <div className="integration-innerlayout">
              <img
                className="icon-img me-3"
                src={whatsapplogo}
                alt="whatsapp"
              />
              <span>
                <small className="integration-chat">Whatsapp</small>
              </span>
              <h1 className="integration-message mt-2">
                Receive new leads from whatsapp and redirect them to your
                mimokonnect account
              </h1>
              <div className="d-flex justify-content-between mt-3">
                <small className="integration-notConnect">
                  {!whatsappSetting?.appName ? "Not Connect" : "Connected"}
                </small>
                <small className="integration-connect">
                    <Link to="whatsapp">Connect &nbsp;{">"}</Link>
                </small>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
export default React.memo(Integration);
